import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import ErrorBoundary from './components/ErrorBoundary';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import ServicePredictor from './pages/ServicePredictor';
import About from './pages/About';

declare global {
  interface Window {
    runtimeConfig: {
      TSP_APP_BASE_URL: string;
      TSP_APP_MAIN_URL: string;
      MAPBOX_KEY: string;
      TSP_APP_PLATFORM: string;
      TSP_DEV_ONLY_FEATURE: string;
      EMAIL: string;
      TARANA_KEY: string;
      SAIL_INTERNET_KEY: string;
      REMOTE_ADDRESS: string;
    };
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Navigation />
        <Box
          component="main"
          sx={{
            flex: 1,
            width: '100%',
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/predictor" element={<ServicePredictor />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Box>
      </Box>
    </ErrorBoundary>
  );
}

export default App;
